import toDate from "./toDate.js";
const getGreaterDate = (date1Param, date2Param)=>{
    const date1 = 'string' == typeof date1Param ? toDate(date1Param) : date1Param;
    const date2 = 'string' == typeof date2Param ? toDate(date2Param) : date2Param;
    if (!date1 && !date2) return;
    if (!date1) return date2;
    if (!date2) return date1;
    return date1.getTime() > date2.getTime() ? date1 : date2;
};
const date_getGreaterDate = getGreaterDate;
export default date_getGreaterDate;
